// Implied price check for preferred classes — emergent feature (S2). Engine layer (framework-free).
import { impliedPerShare } from './backsolve';
/**
 * For every preferred class with a positive issue price, compare the original
 * issue price against the per-share value implied by allocating V across the
 * breakpoint schedule. Useful as a sanity check on direct/tender equity values.
 */
export function impliedPriceCheck(V, bps, inputs) {
    const cap = inputs.capTableSnapshot;
    const rows = [];
    for (const inst of cap.instruments) {
        if (inst.kind !== 'preferred' || inst.issuePrice <= 0)
            continue;
        const implied = impliedPerShare(V, inst.id, bps, inputs);
        const deltaPct = inst.issuePrice > 0 ? (implied - inst.issuePrice) / inst.issuePrice : 0;
        rows.push({
            instrumentId: inst.id,
            name: inst.name,
            issueDate: inst.issueDate,
            issuePrice: inst.issuePrice,
            impliedPerShare: implied,
            deltaPct,
        });
    }
    return rows;
}
//# sourceMappingURL=impliedPriceCheck.js.map